<script context="module" lang="ts">
  enum Types {
    Button = 'button'
  }

  export const IconTypes = Types;
</script>

<script lang="ts">
  export let type: Types | string = '';
  export let value = '';
  export let disabled = false;
  export let size = '16px';
  export let fontSize = '16px';
  export let name = value;

  let sizeClassname = '';
  let fontSizeClassname = '';

  $: if (size) {
    sizeClassname = `icon-size-${size}`;
  }

  $: if (fontSize) {
    fontSizeClassname = `icon-font-size-${fontSize}`;
  }

  $: classnames = `comp-icon ${value} ${sizeClassname} ${fontSizeClassname}`;
</script>

{#if type === Types.Button}
  <button
    data-cy={name}
    type="button"
    class={classnames}
    {disabled}
    on:click|preventDefault|stopPropagation
  >
    <slot />
  </button>
{:else}
  <span data-cy={name} class={classnames}>{''}</span>
{/if}

<style src="./Icon.css">
</style>
